import { forwardRef } from 'react';
import { RootComponent } from '../../services/root-component';
import { EntryProps } from './types';
import css from './style.module.css';

export const Entry = forwardRef<HTMLElement, EntryProps>(function Component(
  { children, ...restProps },
  forwardedRef
) {
  return (
    <RootComponent {...restProps} baseClassName={css.root} ref={forwardedRef}>
      <div className={css.scroll}>{children}</div>
    </RootComponent>
  );
});
